module.exports = __webpack_public_path__ + "media/images/smile-4-c639c95c52ba895417a48fe4af16b119.svg";